import { Box, Flex, HStack, IconButton, Text } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { User } from "../apis";

export interface AppRenderDetailChatItemProps {
    users: User[];
    onClick: (user: User) => void;
    label?: string;
}

export const AppRenderDetailChatItem = ({
    users,
    onClick,
    label = "",
}: AppRenderDetailChatItemProps) => {
    return (
        <Flex direction={"column"} gap={1.5} w={"full"}>
            {label && (
                <Box textStyle={"mediumXs"} textDecoration={"underline"}>
                    {label}
                </Box>
            )}
            {Array.isArray(users) && users.length > 0 ? (
                <Flex wrap="wrap" gap={1.5}>
                    {users.map((user, index) => (
                        <HStack
                            key={index}
                            bg={"var(--chakra-colors-primaryT80)"}
                            ps={2}
                            borderRadius={8}
                        >
                            <Text lineHeight={1} textTransform={"capitalize"}>
                                {user?.meta?.fullName}
                            </Text>
                            <IconButton
                                w={"24px"}
                                h={"24px"}
                                variant={"primary"}
                                aria-label="comment-bubble-lines"
                                icon={
                                    <AppIcon
                                        name="ics-comment-bubble-lines"
                                        w="1rem"
                                    />
                                }
                                borderRadius={8}
                                onClick={() => {
                                    if (onClick) {
                                        onClick(user);
                                    }
                                }}
                            />
                        </HStack>
                    ))}
                </Flex>
            ) : (
                <Box textStyle="regularSm">-</Box>
            )}
        </Flex>
    );
};
